import { render, staticRenderFns } from "./LoginForeign.vue?vue&type=template&id=0415547e&"
import script from "./LoginForeign.vue?vue&type=script&lang=js&"
export * from "./LoginForeign.vue?vue&type=script&lang=js&"
import style0 from "./LoginForeign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports